import { SafetyCertificateOutlined } from "@ant-design/icons";
import { BodhiButton, BodhiCard } from "@bodhistreams/ui";
import "./CertificateGate.css";

const CertificateGate = ({ onBack, onViewPlans }) => {
	return (
		<div className="cert-gate">
			<BodhiCard className="cert-gate-card" hoverable={false}>
				<SafetyCertificateOutlined className="cert-gate-icon" />
				<h2 className="cert-gate-title">Paid membership required</h2>
				<p className="cert-gate-text">
					This certificate is only available for non-free subscribers with an
					active Bodhistreams plan.
				</p>
				<div className="cert-gate-actions">
					<BodhiButton variant="ghost" onClick={onBack}>
						Back to Profile
					</BodhiButton>
					<BodhiButton variant="primary" onClick={onViewPlans}>
						View Plans
					</BodhiButton>
				</div>
			</BodhiCard>
		</div>
	);
};

export default CertificateGate;
